import { useRef, useState } from 'react'

import ArrowLeftIcon from '@/assets/svg/ArrowLeftIcon'
import ArrowRightIcon from '@/assets/svg/ArrowRightIcon'
import { getWindowDimensions } from '@/utils/common'

export default function Carousel({ slides }) {
  const carouselRef = useRef(null)
  let [current, setCurrent] = useState(0)
  const { width } = getWindowDimensions()
  let translateXValue = current * 618
  if (width >= 768 && width < 1280) {
    translateXValue = current * 734
  }
  if (width < 768) {
    translateXValue = current * 341
  }
  let previousSlide = () => {
    if (current === 0) setCurrent(slides.length - 1)
    else setCurrent(current - 1)
  }
  let nextSlide = () => {
    if (current === slides.length - 1) setCurrent(0)
    else setCurrent(current + 1)
  }
  const onScroll = () => {
    const totalWidth = carouselRef.current.offsetWidth
    const widthPerPart = Math.floor(totalWidth / slides.length)
    let position =
      slides.length -
      (totalWidth - carouselRef.current.scrollLeft) / widthPerPart
    if (position > slides.length - 1) position = slides.length - 1
    // setCurrent(Math.floor(position))
  }
  return (
    <div className="relative w-full">
      <div
        onScroll={onScroll}
        ref={carouselRef}
        className="flex flex-nowrap no-scrollbar overflow-hidden relative gap-[30px] lg:pt-14 pt-10 lg:pb-[66px] pb-[50px] lg:px-10 px-8"
      >
        <div
          className={`flex transition ease-out duration-40 gap-[30px]  `}
          style={{
            transform: `translateX(-${translateXValue}px)`,
          }}
        >
          {slides.map(slide => {
            return slide
          })}
        </div>
        <div
          aria-hidden="true"
          className={`lg:flex transition ease-out duration-40 gap-[30px] hidden`}
          style={{
            transform: `translateX(-${translateXValue}px)`,
          }}
        >
          {slides.map(slide => {
            return slide
          })}
        </div>
      </div>
      <div
        id="customer-carousel-dot"
        className="absolute bottom-0 flex w-full justify-center gap-3 "
      >
        {slides.map((s, i) => {
          return (
            <div
              onClick={() => {
                setCurrent(i)
              }}
              key={'circle' + i}
              className={`rounded-full w-[10px] h-[10px] cursor-pointer  ${
                i == current.toFixed(0)
                  ? 'bg-brand-primary-500'
                  : 'bg-brand-primary-100'
              }`}
            ></div>
          )
        })}
      </div>
      <div className="absolute  top-0 h-full  justify-between items-center flex text-white text-3xl z-50 cursor-pointer">
        <button
          id="customer-arrow-left"
          className="xl:left-[-12px] ml-[-4px]  p-4 !outline-none"
          onClick={previousSlide}
        >
          <ArrowLeftIcon />
        </button>
      </div>
      <div className="absolute  top-0 h-full right-0 justify-between items-center flex text-white text-3xl z-50 cursor-pointer">
        <button
          id="customer-arrow-right"
          className="xl:mr-[-12px] md:mr-[-4px] p-4 pr-[10px]  !outline-none"
          onClick={nextSlide}
        >
          <ArrowRightIcon />
        </button>
      </div>
    </div>
  )
}
